
import { InterceptMiddle } from '../../regular';
/**
 * 判断排序题OrderExist[QuestionLabel: Number: Numbers]
 * @param condition 条件str
 * @param list 试题list
 * @return Boolean
 */
export const OrderExist = (list, condition) => {
    // OrderExist[Q1:1:2,3]
    if (!condition) return false
    let result = false
    try {
        let code = InterceptMiddle(condition.split(':')[0], ['['], ['==', '>', '>=', '<', '<=', '_', ':'])
        let num1 = condition.split(':')[1]
        let num2 = InterceptMiddle(condition.split(':')[2], [':'], [']'])
        let nums = num2.split(',')
        list.forEach(info => {
            if (code == info.quesCode && info.bindIsShow && info.isShow && info.questionsTypeId == '14') {
                nums.forEach((n) => {
                    if(info.optionList[n - 1].oid == info.userAnswerArr[num1 - 1]){
                        result = true
                    }
                })
            }
        })
        return result;
    } catch (error) {
        console.log('error :>> ', error);
        return false
    }
}